<template>
  <div class="app-fio_afo">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`app-fio-group-${i}`"
        @click="removeError(i)"
        class="input-group">

        <div class="afo_cols">

          <div class="afo_col">
            <div class="input-subtitle" :class="{ ['required']: options.required }">
              Ваша фамилия</div>
            <el-input
              v-model="valueLocal[i].surname"
              :class="{ 'child-has-error': error[i].surname }"
              :key="`app-fio-surname-${i}`"/>
          </div>

          <div class="afo_col">
            <div class="input-subtitle"
                 :class="{ ['required']: options.required }">Ваше имя</div>
            <el-input
              v-model="valueLocal[i].name"
              :class="{ 'child-has-error': error[i].name }"
              :key="`app-fio-name-${i}`"/>
          </div>

          <div class="afo_col">
            <div class="input-subtitle">Ваше отчество</div>
            <el-input
              v-model="valueLocal[i].patronymic"
              :key="`app-fio-patronymic-${i}`"/>
          </div>

        </div>

        <div v-if="error[i].name || error[i].surname" class="ait_message ait_message--error">
          {{ error[i].name ? error[i].name : (error[i].surname ? error[i].surname : '') }}</div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        surname: '',
        name: '',
        patronymic: '',
      },
      errorBase: { name: '', surname: '' },
    };
  },

  methods: {

    setValue(fio) {
      if (fio.surname) this.valueLocal[0].surname = fio.surname;
      if (fio.name) this.valueLocal[0].name = fio.name;
      if (fio.patronymic) this.valueLocal[0].patronymic = fio.patronymic;
    },

    getError() {
      // Check if required (validate name and surname)
      if (this.options.required) {
        this.valueLocal.forEach((el, i) => {
          this.error[i].name = el.name ? '' : this.validateMessages.required;
          this.error[i].surname = el.surname ? '' : this.validateMessages.required;
        });
      }
      this.updateError();
      return this.error;
    },

    removeError(i) {
      this.error[i].name = '';
      this.error[i].surname = '';
      this.updateError();
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-fio_afo {
  @include clearfix;
  .afo_cols {
    padding: 0;
    margin: 0 -5px -5px;
    clear: both;
  }
  .afo_col {
    float: left;
    width: 33.3333333%;
    padding: 5px;
  }
  @media (max-width: 750px) {
    .afo_col {
      float: none;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppFio.vue